import { render, staticRenderFns } from "./AddEditSuggestions.vue?vue&type=template&id=380b4da6"
import script from "./AddEditSuggestions.vue?vue&type=script&lang=js"
export * from "./AddEditSuggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports